import { ScaleType, RootNote, ChordQuality } from '../../types';

// Scale interval patterns (semitones from root)
export const SCALE_INTERVALS: Record<ScaleType, number[]> = {
    chromatic: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
    major: [0, 2, 4, 5, 7, 9, 11],
    minor: [0, 2, 3, 5, 7, 8, 10],
    pentatonic_major: [0, 2, 4, 7, 9],
    pentatonic_minor: [0, 3, 5, 7, 10],
    blues: [0, 3, 5, 6, 7, 10],
    dorian: [0, 2, 3, 5, 7, 9, 10],
    phrygian: [0, 1, 3, 5, 7, 8, 10],
    lydian: [0, 2, 4, 6, 7, 9, 11],
    mixolydian: [0, 2, 4, 5, 7, 9, 10],
    harmonic_minor: [0, 2, 3, 5, 7, 8, 11],
    melodic_minor: [0, 2, 3, 5, 7, 9, 11]
};

export const ROOT_NOTE_MIDI: Record<RootNote, number> = {
    'C': 0, 'C#': 1, 'D': 2, 'D#': 3, 'E': 4, 'F': 5,
    'F#': 6, 'G': 7, 'G#': 8, 'A': 9, 'A#': 10, 'B': 11
};

/**
 * Chord intervals (semitones from root)
 */
export const CHORD_INTERVALS: Record<ChordQuality, number[]> = {
    major: [0, 4, 7],           // Root, Major 3rd, Perfect 5th
    minor: [0, 3, 7],           // Root, Minor 3rd, Perfect 5th
    diminished: [0, 3, 6],      // Root, Minor 3rd, Diminished 5th
    augmented: [0, 4, 8],       // Root, Major 3rd, Augmented 5th
    dominant7: [0, 4, 7, 10],   // Root, Major 3rd, Perfect 5th, Minor 7th
    minor7: [0, 3, 7, 10],      // Root, Minor 3rd, Perfect 5th, Minor 7th
    sus2: [0, 2, 7],            // Root, Major 2nd, Perfect 5th
    sus4: [0, 5, 7],            // Root, Perfect 4th, Perfect 5th
};

/**
 * Scale degree chord qualities for each scale type
 * These define which chord quality to use for each scale degree
 */
export const SCALE_CHORD_QUALITIES: Record<ScaleType, ChordQuality[]> = {
    // Major Scale: I-ii-iii-IV-V-vi-vii°
    major: ['major', 'minor', 'minor', 'major', 'major', 'minor', 'diminished'],

    // Natural Minor Scale: i-ii°-III-iv-v-VI-VII
    minor: ['minor', 'diminished', 'major', 'minor', 'minor', 'major', 'major'],

    // Harmonic Minor Scale: i-ii°-III+-iv-V-VI-vii°
    harmonic_minor: ['minor', 'diminished', 'augmented', 'minor', 'major', 'major', 'diminished'],

    // Melodic Minor Scale: i-ii-III+-IV-V-vi°-vii°
    melodic_minor: ['minor', 'minor', 'augmented', 'major', 'major', 'diminished', 'diminished'],

    // Pentatonic Major: I-ii(sus2)-iii(sus2)-V-vi(sus2)
    pentatonic_major: ['major', 'sus2', 'sus2', 'major', 'sus2'],

    // Pentatonic Minor: i-III-iv-v-VII
    pentatonic_minor: ['minor', 'major', 'minor', 'minor', 'major'],

    // Blues Scale: i7-iv7-V7 (simplified to 3 main chords)
    blues: ['minor7', 'minor7', 'dominant7', 'minor7', 'dominant7', 'minor7'],

    // Dorian Mode: i-ii-III-IV-v-vi°-VII
    dorian: ['minor', 'minor', 'major', 'major', 'minor', 'diminished', 'major'],

    // Phrygian Mode: i-II-III-iv-v°-VI-vii
    phrygian: ['minor', 'major', 'major', 'minor', 'diminished', 'major', 'minor'],

    // Lydian Mode: I-II-iii-#iv°-V-vi-vii
    lydian: ['major', 'major', 'minor', 'diminished', 'major', 'minor', 'minor'],

    // Mixolydian Mode: I-ii-iii°-IV-v-vi-VII
    mixolydian: ['major', 'minor', 'diminished', 'major', 'minor', 'minor', 'major'],

    // Chromatic: All chord types available (random selection)
    chromatic: ['major', 'minor', 'diminished', 'augmented', 'dominant7', 'minor7', 'sus2', 'sus4', 'major', 'minor', 'diminished', 'augmented'],
};
